export default {"src":"/_next/static/media/download-aperture.c1d2b8bb.svg","height":900,"width":1080,"blurWidth":0,"blurHeight":0};